import { ComponentPropsWithRef } from 'react';

import { PosMultiSelect } from './PosMultiSelect';
import { EnumMultiSelectValueChange } from './PosMultiSelect.types';

export type PosEnumMultiSelectProps<EnumType extends string> = {
  values: EnumType[];
  defaultValue?: EnumType | null;
  valueOptionsContent: Record<EnumType, string>;
  onChange: (change: EnumMultiSelectValueChange<EnumType>) => void;
} & Omit<
  ComponentPropsWithRef<typeof PosMultiSelect>,
  'values' | 'valueOptionsContent' | 'onChange' | 'defaultValue'
>;

export function PosEnumMultiSelect<EnumType extends string>({
  values,
  defaultValue,
  onChange,
  valueOptionsContent,
  ...rest
}: PosEnumMultiSelectProps<EnumType>) {
  return (
    <PosMultiSelect
      values={values.map((v) => v as string)}
      defaultValue={
        defaultValue === undefined
          ? undefined
          : defaultValue === null
            ? ''
            : defaultValue
      }
      onChange={({ newValues, operation }) => {
        onChange({ newValues: newValues.map((v) => v as EnumType), operation });
      }}
      valueOptionsContent={valueOptionsContent}
      {...rest}
    />
  );
}
